import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { Redirect, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { auth, main } from 'routes/route.map'
import { StoreContext } from 'store/context'
import { Button, Link } from 'shared/components'
import styles from './styles'

export const renderIfAuthenticated = (Component) =>
  observer((props) => {
    const appStore = useContext(StoreContext)
    const { isSignedIn } = appStore.auth
    const browserWindow = globalThis.window
    const isBrowser = !!browserWindow
    const userAgent = globalThis.navigator?.userAgent ?? ''
    const {
      location: { pathname, search },
    } = props
    const { noRedirect } = queryString.parse(search)

    // Check if user is on mobile/tablet
    const isMobileOrTablet = isBrowser &&
      (browserWindow.innerWidth <= 1024 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent))

    // Debug logging for logout redirect behavior
    if (!isSignedIn && isBrowser) {
      console.log('User not authenticated, redirecting to:', isMobileOrTablet ? '/main (mobile - will show third onboarding screen)' : auth.login() + ' (desktop - login page)')
    }

    return isSignedIn ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: isMobileOrTablet ? '/main' : auth.login(),
          search: noRedirect
            ? null
            : queryString.stringify({
              redirectTo: pathname + search,
            }),
          state: { redirected: true },
        }}
      />
    )
  })

export const renderIfNotAuthenticated = (Component) =>
  observer((props) => {
    const appStore = useContext(StoreContext)
    const { isSignedIn } = appStore.auth

    const { search, state, pathname } = props.location
    const { redirectTo } = queryString.parse(search)
    const redirectUrl = redirectTo || main.index()
    const searchPosition = redirectUrl.indexOf('?')
    const hasSearch = searchPosition !== -1
    const searchStr = hasSearch ? redirectUrl.slice(searchPosition) : ''
    const pureRedirectUrl = hasSearch
      ? redirectUrl.slice(0, searchPosition)
      : redirectUrl

    return !isSignedIn ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: pureRedirectUrl,
          search: searchStr,
          state,
        }}
      />
    )
  })

export const renderLoginTipsIfNotAuthenticated = (Component) =>
  observer((props) => {
    const appStore = useContext(StoreContext)
    const history = useHistory()
    const { isSignedIn } = appStore.auth

    return isSignedIn ? (
      <Component {...props} />
    ) : (
      <div css={styles.top}>
        <h3 css={styles.topTitle}>Never miss a game</h3>
        <p css={styles.description}>
          Become an InWin member to see all the tournaments and <br /> be able
          to cheer for your favorite team!
        </p>
        <Button
          css={styles.signUpBtn}
          text="Sign Up"
          onClick={() => history.push('/auth/signUp')}
        />
        <span css={styles.logInText}>
          Already have an account?{' '}
          <Link css={styles.logInLink} to="/auth/login">
            Log in
          </Link>
        </span>
      </div>
    )
  })

export const permittedFor = (validator) => (Component) =>
  observer((props) =>
    validator(props) ? <Component {...props} /> : <Redirect to={main.index()} />
  )

export const permittedForRoles =
  (...roles) =>
    (Component) =>
      observer((props) => {
        const appStore = useContext(StoreContext)
        const { isSignedIn, loggedEntity } = appStore.auth
        const hasPermissions = isSignedIn && roles.includes(loggedEntity.role)

        return hasPermissions ? (
          <Component {...props} />
        ) : (
          <Redirect to={main.index()} />
        )
      })
